import CardCarousel from './components/CardCarousel/CardCarousel';

export {CardCarousel};

export default CardCarousel;
